export const getTypeName = (isSubscription: boolean): string => {
  return isSubscription ? 'подписки' : 'пакета';
};
